
  import { defineComponent, ref, reactive, watch, inject, onMounted, nextTick } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import api from "@/api/axios";
  import wx from "weixin-sdk-js";
  import axios from "@/api/axios";
  import useFootPrint from "@/hooks/useFootPrint";
  import SlotFooter from "@/components/common/SlotFooter.vue";
  import Loading from "@/components/UI/Loading";
  import navigatorType from "@/utils/browser";

  export default defineComponent({
    name: "productdetail",
    components: {
      SlotFooter,
      Loading,
    },
    setup() {
      const shareTitle = ref('')
      const route = useRoute();
      const router = useRouter();
      const id = ref(route.params.id);
      const classId = ref(route.params.classId);
      const isFav = ref(false);
      const productsVO = ref(null);
      const list = ref([]);
      const secListComp = ref([]);
      const amclass = ref(null);
      const comp = ref({});
      const RelatedProIdList = ref([]);
      const { setFootItem } = useFootPrint();
      const listCompLen = ref(0);
      const  productLotList = ref()
      const lotid = ref()
      const tcid = ref(0)
      const specChecked = ref(true)
      const productPrice = ref()
      const isLogin = ref()
      const originalPrice = ref()
      const productStock = ref()
      const biaowuPriceOpen = ref()
      const isApplyOpen = ref()
      const productPdfHref = ref()
      //  展示用户信息
      const userInfo = inject("userInfo") as any;
      function getData(id: any) {
        productsVO.value = null;
        api
                .get("/M/Product/ProductDetail/" + id)
                .then((res): void => {
                  const data = res.data.obj;
                  isApplyOpen.value = data.isApplyOpen;
                  if(!isApplyOpen.value){
                    isApplyOpen.value =0;
                  }
                  biaowuPriceOpen.value = data.biaowuPriceOpen
                  if (data.productsVO.nongdu && data.productsVO.nongdu.indexOf('(') != -1) {
                    const index = data.productsVO.nongdu.indexOf('(')
                    data.productsVO.nongdu = data.productsVO.nongdu.substring(0, index)
                  }
                  productsVO.value = data.productsVO;
                  productPdfHref.value = data.productPdfHref
                  document.title = data.productsVO.cnname + "-北纳标物网";
                  shareTitle.value = data.productsVO.cnname
                  route.meta.title = data.productsVO.cnname
                  route.meta.content.description = data.description;
                  list.value = data.listComp;
                  comp.value = data.comp;
                  isFav.value = data.isFav;
                  amclass.value = data.amclass;
                  RelatedProIdList.value = data.RelatedProIdList;
                  secListComp.value = data.secListComp;
                  listCompLen.value = data.listComp.length;
                  data.productLotList.length>1 && data.productLotList.forEach((item: any) => {
                    item.specChecked = false
                  })
                  if(data.productLotList.length>1){
                    data.productLotList[0].specChecked = true;
                    lotid.value = data.productLotList[0].lotid
                  }
                  productLotList.value = data.productLotList
                  const isPc = navigatorType();
                  if (isPc) {
                    window.location.href = `http://www.biaowu.com/p_${data.productsVO.classId}/p_${data.productsVO.id}.html`;
                  }

                  // 判断价格
                  // 判断是否登录
                  const loginUser = data.loginUser
                  isLogin.value = data.loginUser
                  if (productLotList.value.length>1) {
                    productStock.value = data.productLotList[0].stock
                    if (data.productsVO.suppliercode == 1) {
                      if (loginUser) {
                        productPrice.value = Math.ceil(Number(data.productLotList[0].outPrice)*(loginUser.discount?loginUser.discount:1))
                        originalPrice.value = Math.ceil(Number((data.productLotList[0].outPrice)))
                      } else {
                        productPrice.value = Math.ceil(Number((data.productLotList[0].outPrice)))
                      }
                    }else{
                      productPrice.value = Math.ceil(Number(data.productLotList[0].outPrice))
                    }

                  }else{
                    productStock.value = (productsVO.value as any).stock
                    if (data.productsVO.suppliercode == 1) {
                      if (loginUser) {
                        productPrice.value =  Math.ceil(Number((productsVO.value as any).retailPrice)*(loginUser.discount?loginUser.discount:1))
                        originalPrice.value = Math.ceil(Number((productsVO.value as any).retailPrice))
                      } else {
                        productPrice.value = Math.ceil(Number((productsVO.value as any).retailPrice))
                      }
                    }else{
                      productPrice.value = Math.ceil(Number((productsVO.value as any).retailPrice))
                    }
                  }

                  /**
                   *  存足迹
                   */
                  setFootItem({
                    type: "product",
                    img: (productsVO.value as any).switchPic,
                    title: (productsVO.value as any).cnname,
                    info: (productsVO.value as any).catno,
                    proid: (productsVO.value as any).id,
                    brand: (productsVO.value as any).suppliercode
                            ? "标准值" + (productsVO.value as any).suppliercode + "组分"
                            : (productsVO.value as any).suppliercode,
                    specification: (productsVO.value as any).specification,
                    concentration: (productsVO.value as any).concentration,
                    url: { name: "productdetail", params: { id: route.query.id } },
                  });
                })
                .catch((err) => {
                  console.log(err);
                });


      }
      getData(id.value);
      function clickSpec(item: any, index: any) {
        productStock.value = item.stock
        lotid.value = item.lotid;

        productLotList.value.length>1 && productLotList.value.forEach((item: any) => {
          item.specChecked = false
        })
        productLotList.value[index].specChecked = true
        specChecked.value = false

        // 判断是否登录
        if (userInfo) {
          if ((productsVO.value as any).suppliercode == 1) {
            productPrice.value = Math.ceil(Number(item.outPrice)*(userInfo.discount?userInfo.discount:1))
          } else {
            productPrice.value = Math.ceil(Number(item.outPrice))
          }
        } else {
          productPrice.value = Math.ceil(Number(item.outPrice))
        }

      }
      function firstSpec() {
        if(!productLotList.value[0]) {
          return false
        }
        lotid.value = productLotList.value[0].lotid
        specChecked.value = true
        productLotList.value.length>0 && productLotList.value.forEach((item: any) => {
          item.specChecked = false
        })
      }
      watch(
              [
                () => {
                  return route.query;
                },
                () => {
                  return route.params;
                },
              ],
              (to, from) => {
                // 避免登录时触发页面刷新
                console.log(to, from);
                if (to[1].id && !from[1].valid && !from[1].validate) {
                  getData(to[1].id as string);
                }
              }
      );

      watch(
              () => {
                return shareTitle.value
              },
              (to, from) => {
                const isweixin = ref(false);
                const ua = navigator.userAgent.toLowerCase();
                const reg = /MicroMessenger/i;
                isweixin.value = reg.test(ua);
                if (isweixin.value) {
                  nextTick(() => {
                    // const imgUrl = "http://shijiaoke.oss-cn-beijing.aliyuncs.com/Yunan/logo20200923.svg";
                    const link = window.location.href;
                    const title = document.title;
                    const desc = (document.querySelectorAll(
                            "meta[name=description]"
                    )[0] as any).content;
                    console.log(desc);

                    const formData = new FormData();
                    formData.append("url", link);
                    axios.post("/M/Server/getweixin", formData).then((res: any) => {
                      const data = res.data;
                      wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: data.appid, // 必填，公众号的唯一标识
                        timestamp: parseInt(data.timestamp), // 必填，生成签名的时间戳
                        nonceStr: data.nonceStr, // 必填，生成签名的随机串
                        signature: data.str, // 必填，签名
                        jsApiList: [
                          "checkJsApi",
                          "updateAppMessageShareData",
                          "updateTimelineShareData",
                        ], // 必填，需要使用的JS接口列表
                      });
                      wx.ready(function () {
                        //需在用户可能点击分享按钮前就先调用

                        wx.updateAppMessageShareData({
                          title: to+'-北纳生物', // 分享标题
                          desc: route.meta.content.description, // 分享描述
                          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                          imgUrl: (productsVO.value as any).pic || "https://beinabncc.oss-cn-beijing.aliyuncs.com/News/72bd4bed20c9be16bbe779d66699e17c.jpg", // 分享图标
                          success: function () {
                            // 设置成功
                          },
                        });
                        wx.updateTimelineShareData({
                          title: to+'-北纳生物', // 分享标题
                          desc: route.meta.content.description, // 分享描述
                          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                          imgUrl: (productsVO.value as any).pic || "https://beinabncc.oss-cn-beijing.aliyuncs.com/News/72bd4bed20c9be16bbe779d66699e17c.jpg", // 分享图标
                          success: function () {
                            // 设置成功
                          },
                        });
                      });
                    });
                  });
                }
              }
      )

      const loadOption = {
        text: "加载中...",
        color: "#df0024",
        textColor: "#df0024",
      };
      return {
        productsVO,
        list,
        amclass,
        comp,
        id,
        classId,
        isFav,
        RelatedProIdList,
        loadOption,
        secListComp,
        listCompLen,
        productLotList,
        clickSpec,
        specChecked,
        firstSpec,
        lotid,
        tcid,
        productPrice,
        originalPrice,
        isLogin,
        biaowuPriceOpen,
        productPdfHref,
        productStock,
        isApplyOpen
      };
    },
  });

